'use strict';

/**
 * Initializes the password pattern validation
 * @returns {void}
 */
function initPasswordPattern() {
    const password = document.querySelector('.password');

    const helperText = {
        charLength: document.querySelector('.helper-text .length'),
        lowercase: document.querySelector('.helper-text .lowercase'),
        uppercase: document.querySelector('.helper-text .uppercase'),
        special: document.querySelector('.helper-text .special'),
        number: document.querySelector('.helper-text .number')
    };

    const pattern = {
        // eslint-disable-next-line consistent-return
        charLength: function () {
            if (password.value.length >= 8) {
                return true;
            }
        },
        // eslint-disable-next-line consistent-return
        lowercase: function () {
            const regex = /^(?=.*[a-z]).+$/; // Lowercase character pattern

            if (regex.test(password.value)) {
                return true;
            }
        },
        // eslint-disable-next-line consistent-return
        uppercase: function () {
            const regex = /^(?=.*[A-Z]).+$/; // Uppercase character pattern

            if (regex.test(password.value)) {
                return true;
            }
        },
        // eslint-disable-next-line consistent-return
        special: function () {
            const regex = /^(?=.*[_\W])(?!.*\s).+$/; // Special character or number pattern

            if (regex.test(password.value)) {
                return true;
            }
        },
        // eslint-disable-next-line consistent-return
        number: function () {
            const regex = /^(?=.*\d).+$/; //  number pattern

            if (regex.test(password.value)) {
                return true;
            }
        }
    };

    // Listen for keyup action on password field
    if (password) {
        const checkPattern = function () {
            // Check that password is a minimum of 8 characters
            patternTest(pattern.charLength(), helperText.charLength);

            // Check that password contains a lowercase letter
            patternTest(pattern.lowercase(), helperText.lowercase);

            // Check that password contains an uppercase letter
            patternTest(pattern.uppercase(), helperText.uppercase);

            // Check that password contains a number or special character
            patternTest(pattern.special(), helperText.special);
            patternTest(pattern.number(), helperText.number);

            // Check that all requirements are fulfilled
            if (hasClass(helperText.charLength, 'valid')
                && hasClass(helperText.lowercase, 'valid')
                && hasClass(helperText.uppercase, 'valid')
                && hasClass(helperText.special, 'valid')
                && hasClass(helperText.number, 'valid')
            ) {
                addClass(password, 'is-valid');
                removeClass(password, 'is-invalid');
            } else {
                removeClass(password, 'is-valid');
                addClass(password, 'is-invalid');
            }
        };
        password.addEventListener('focus', checkPattern);
        password.addEventListener('keyup', checkPattern);
    }

    /**
    * Tests a given pattern and adds/removes a class to a response element
    * @param {string} pattern - the pattern to test
    * @param {HTMLElement} response - the response element to add/remove the class from
    */
    // eslint-disable-next-line no-shadow, require-jsdoc
    function patternTest(pattern, response) {
        if (pattern) {
            addClass(response, 'valid');
            removeClass(response, 'invalid');
        } else {
            removeClass(response, 'valid');
            addClass(response, 'invalid');
        }
    }

    /**
    * Adds a class to an element
    * @param {HTMLElement} el - the element to add the class to
    * @param {string} className - the class to add
    */
    function addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += ' ' + className;
        }
    }

    /**
    * Removes a class from an element
    * @param {HTMLElement} el - the element to remove the class from
    * @param {string} className - the class to be removed
    */
    function removeClass(el, className) {
        if (el.classList) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    /**
    * Checks if an element has the specified class
    * @param {Object} el - the element to check
    * @param {string} className - the class to check for
    * @returns {boolean} - true if the element has the class, false otherwise
    */
    // eslint-disable-next-line consistent-return, require-jsdoc
    function hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        }

        return false;
    }
}

module.exports = {
    initPasswordPattern: initPasswordPattern
};
